import { Controller } from 'stimulus'
import autoComplete from '@tarekraafat/autocomplete.js'
import { fetch } from 'shared/js/fetch'
import { getUrlParams, setParamToUrl, removeValueOfParamToUrl } from 'shared/js/common';
import NProgress from 'nprogress'
import $ from 'jquery'

export default class extends Controller {

  static targets = [ 'field', 'query', 'form', 'autocomplete', 'results', 'pagination', 'location', 'filter']

  connect() {
    this.hijackPagination()
    this.autoComplete = this.initializeAutocomplete()
  }

  initializeAutocomplete() {
    return new autoComplete(
      {
        data: {
          src: () => this.autocomplete(),
          key: ['text'],
          cache: false,
      },
      resultsList: {
        render: true,
        destination: this.autocompleteTarget,
        position: 'beforeend',
        container: (list) => {
          list.classList.add('border', 'border-t-0', 'bg-white', 'rounded-b', 'shadow-md')
          list.addEventListener('mouseenter', () => this.inAutocomplete = true)
          list.addEventListener('mouseleave', () => this.inAutocomplete = false)
        }
      },
      resultItem: {
        content: (result, resultElement) => {
          resultElement.classList.add('block', 'cursor-pointer', 'px-3', 'py-2', 'hover:bg-gray-200')
          resultElement.addEventListener('click', () => this.resultSelected(result.value))
          resultElement.innerHTML = result.match
        }
      },
      selector: () => this.queryTarget,
      threshold: 2,
      debounce: 300,
      searchEngine: (query, resultText) => {
        // handle product ID searches where result text doesn't match the query
        return this.autoComplete.search(query, resultText) || resultText
      },
      highlight: true,
      onSelection: ({ selection }) => this.resultSelected(selection.value),
    })
  }

  async autocomplete() {
    const response = await fetch(this.autocompleteUrl, {
      query: {
        field: this.fieldTarget.value,
        query: this.queryTarget.value,
      }
    })

    const data = await response.json()

    return data['items']
  }

  resultSelected({ text, link }) {
    this.queryTarget.value = text
    this.hideAutocomplete()

    if (link) {
      window.location.href = link
    } else {
      this.search({ page: 1 })
    }
  }

  onFilterChange(event) {
    $('#search_category').val('');
    $('#search_api').val('');
    $('#search_operation').val('');

    var list_category = $(".category");
    var list_api = $(".api");
    let category_count = 0;
    let api_count = 0;

    let category_query = "";
    let api_query = "";

    var category_checked = document.createDocumentFragment(),category_unchecked = document.createDocumentFragment();
    $('.search-category').each(function(i) {
      let category_value = String($(this).data("ct-name")).toLowerCase()

      if ($(this)[0].children[1].checked) {
        $(this).show();
        category_checked.appendChild($(this)[0]);
      } else {
        category_unchecked.appendChild($(this)[0]);
      }

      if (category_value.includes(category_query)) {
        $(this).removeClass('hidden');
        $(this).show();
          category_count ++;
      }else{
          $(this).hide();
      }
      // if (category_count > 5){
      //   $(this).hide();
      // }
    })
      list_category.replaceWith(list_category.append(category_checked).append(category_unchecked));

    var api_checked = document.createDocumentFragment(),api_unchecked = document.createDocumentFragment();
    $('.search-api').each(function(i) {
      let api_value = String($(this).data("api-name")).toLowerCase()
      if (api_value.includes(api_query)) {
        $(this).removeClass('hidden');
        $(this).show();
          api_count ++;
      }else{
          $(this).hide();
      }
      if (api_count > 5){
        $(this).hide();
      }
      if ($(this)[0].children[1].checked) {
        $(this).show();
        api_checked.appendChild($(this)[0]);
      } else {
        api_unchecked.appendChild($(this)[0]);
      }
    })
    list_api.replaceWith(list_api.append(api_checked).append(api_unchecked));

    const url = new URL(window.location.href);
    const currentValue = event.target.parentElement.dataset.prName;
    if(event.target.parentElement.id === 'search-city') {
      if(event.target.checked) {
        setParamToUrl(url, 'city', currentValue);
      } else {
        removeValueOfParamToUrl(url, 'city', currentValue);
      }
    } else if (event.target.parentElement.id === 'search-country') {
      if(event.target.checked) {
        setParamToUrl(url, 'country', currentValue);
      } else {
        removeValueOfParamToUrl(url, 'country', currentValue);
      }
    }
    window.history.replaceState(null, null, url);
    const city = getUrlParams('city'),
      country = getUrlParams('country');

    this.search({ page: 1, city, country })
  }

  async search({ page, city = null, country = null }) {
    NProgress.start()
    this.resultsTarget.classList.add('opacity-50')
    const formData = new FormData(this.formTarget)
    formData.append('page', page)
    if(city) formData.append('city', city)
    if(country) formData.append('country', country)

    const response = await fetch(this.formTarget.action, { method: 'POST', body: formData })
    const results  = await response.text()

    this.resultsTarget.innerHTML = results
    if($("#loading_complete")[0] != undefined){
      $("#loading_complete")[0].attributes["loading-complete"].value = false;
    }
    $('.product-chart').easyPieChart({
      scaleColor: false,
      lineCap: 'round',
      lineWidth: 6,
      size: 40,
      animate: 1000,
      onStart: $.noop,
      onStop: $.noop,
    });
    $('[data-toggle="tooltip"]').tooltip()   
    this.hijackPagination()

    NProgress.done()
    this.resultsTarget.classList.remove('opacity-50')
    if (city || country) {
      $('meta[name="description"]').attr('content', "Default description")
      $('title').remove();
    } else {
      $('meta[name="description"]').attr('content', "Things To Do - Find Tours, Activities, Attractions and Experiences in locations all over the world.")
      $(document).attr("title", "Things To Do: Tours, Activities and Attractions");
    }
  }

  // allows paginating through search results with POST requests
  hijackPagination() {
    this.paginationTarget.querySelectorAll('.page-link').forEach(element => {
      element.addEventListener('click', (event) => {
        event.preventDefault()

        const match = element.href.match(/page=(\d+)/)
        const page  = match ? match[1] : 1
        const city = getUrlParams('city');
        const country = getUrlParams('country');

        this.search({ page, city, country })
      })
    })
  }

  onChange() {
    if (this.locationTarget.value == "") this.search({ page: 1 })
  }

  onBlur() {
    // delay hiding dropdown when clicking on autocomplete results

    if (!this.inAutocomplete) this.hideAutocomplete()
  }

  onFocus() {
    this.showAutocomplete()
  }

  hideAutocomplete() {
    this.autocompleteTarget.classList.add('hidden')
  }

  showAutocomplete() {
    this.autocompleteTarget.classList.remove('hidden')
  }

  get autocompleteUrl() {
    return this.data.get('autocomplete-url')
  }
}
